import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import JobsMap from "../components/JobsMap";
import { AvailableLaborCard } from "../components/ExternalJobsSection";
import { setPageMeta } from "../lib/seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CityIndexPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    setPageMeta({
      title: "Vagas de Sangrador de Seringueira por Cidade | HeveaTalent",
      description: "Vagas de sangrador de seringueira em Votuporanga, Rio Preto, Fernandópolis e todo o Brasil. Contato direto com a fazenda, grátis. Atualizado hoje.",
      canonical: "https://heveatalent.com.br/vagas",
    });
    axios.get(`${API}/public/cities`).then((res) => setData(res.data)).catch(() => {});
  }, []);

  const byUf = {};
  (data?.cities || []).forEach((c) => {
    const uf = c.uf || "Outras";
    (byUf[uf] = byUf[uf] || []).push(c);
  });
  const ufOrder = Object.keys(byUf).sort((a, b) => {
    const sum = (uf) => byUf[uf].reduce((s, c) => s + c.jobs_count, 0);
    return sum(b) - sum(a) || a.localeCompare(b);
  });

  return (
    <div className="min-h-screen bg-green-50" data-testid="city-index-page">
      <header className="bg-green-900 text-white py-4 px-4">
        <div className="max-w-3xl mx-auto flex items-center justify-between gap-2">
          <Link to="/" className="font-bold text-lg shrink-0">🌳 HeveaTalent</Link>
          <Link to="/">
            <Button size="sm" variant="outline" className="bg-white text-green-900 hover:bg-green-100">
              Entrar / Cadastrar grátis
            </Button>
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto p-4 space-y-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-green-900">Vagas de Sangrador de Seringueira por Cidade</h1>
          <p className="text-sm text-gray-600 mt-1">
            Escolha sua cidade e veja as vagas ativas. Novas cidades entram automaticamente quando surge vaga.
          </p>
        </div>

        <JobsMap />

        {!data ? (
          <p className="text-green-800 text-sm">Carregando cidades...</p>
        ) : (
          ufOrder.map((uf) => (
            <Card key={uf} data-testid={`uf-group-${uf}`}>
              <CardContent className="pt-4 pb-4">
                <p className="text-sm font-semibold text-gray-900 mb-2">
                  {data.uf_names?.[uf] || uf} ({uf})
                </p>
                <div className="flex flex-wrap gap-2">
                  {byUf[uf].map((c) => (
                    <Link key={c.slug} to={`/vagas/${c.slug}`}>
                      <Badge
                        variant={c.jobs_count > 0 ? "default" : "outline"}
                        className={c.jobs_count > 0 ? "bg-green-700 hover:bg-green-800 cursor-pointer" : "cursor-pointer hover:bg-green-50"}
                        data-testid={`city-link-${c.slug}`}
                      >
                        📍 {c.city}{c.jobs_count > 0 ? ` (${c.jobs_count})` : ""}
                      </Badge>
                    </Link>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))
        )}

        <AvailableLaborCard />

        <Card className="bg-green-900 text-white">
          <CardContent className="pt-5 pb-5 text-center">
            <p className="font-semibold">🌳 Tem uma vaga para divulgar?</p>
            <p className="text-sm text-green-200 mt-1">É grátis e sem precisar criar conta — a vaga aparece aqui e no Balcão.</p>
            <Link to="/balcao">
              <Button size="sm" className="mt-3 bg-white text-green-900 hover:bg-green-100" data-testid="index-balcao-btn">
                Divulgar vaga grátis →
              </Button>
            </Link>
          </CardContent>
        </Card>

        <p className="text-center text-xs text-gray-500 pb-6">
          HeveaTalent — o canal de comunicação da heveicultura
        </p>
      </main>
    </div>
  );
}
